import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { noop } from "lodash";
import { Button } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import "./SquaredTabs.scss";

const propTypes = {
  /**
   * Tab label
   */
  label: PropTypes.node.isRequired,
  /**
   * Status of the indicator in the tab
   */
  status: PropTypes.oneOf(["default", "danger", "success", null]),
  /**
   * Display picture on the tab
   */
  picture: PropTypes.string,
  /**
   * Display count on the tab
   */
  count: PropTypes.string,
  /**
   * If true, tab is styled as selected
   */
  isSelected: PropTypes.bool,
  /**
   * Callback when selecting the tab
   */
  onClick: PropTypes.func,
  /**
   * Tab title (show on hover)
   */
  title: PropTypes.string,
  /**
   * If true, tab is disabled
   */
  disabled: PropTypes.bool
};











/**
 * Tab component that contains an status indicator
 */
function SquaredTab(props) {
  const {
    label,
    isSelected = false,
    onClick = noop,
    title = "",
    picture = "",
    count = "",
    status = null,
    disabled = false
  } = props ?? {};

  return (
    <Button
      title={title}
      onClick={() => onClick(!isSelected)}
      className={
      disabled ?
      clsx("Uic-SquaredTabs-baseDisabled") :
      clsx("Uic-SquaredTabs-base", {
        "Uic-SquaredTabs-selected": isSelected
      })
      }
      disabled={disabled}>

      {status &&
      <>
          <p
          className={clsx(
            "Uic-SquaredTabs-status",
            `Uic-SquaredTabs-${status}`
          )} />

          <p
          className={
          isSelected ? "Uic-SquaredTabs-label_sel" : "Uic-SquaredTabs-label"
          }>

            {label}
          </p>
        </>
      }

      {!status && picture &&
      <img
        className={clsx("Uic-SquaredTabs-picture")}
        src={picture}
        alt=" " />

      }
      {!status && count &&
      <h6
        className={clsx(
          isSelected ? "Uic-SquaredTabs-count_sel" : "Uic-SquaredTabs-count",
          picture || count === "" ? "Uic-SquaredTabs-item_text" : {}
        )}>

          {count}
        </h6>
      }
      {!status && label &&
      <>
          <h6 className={clsx("Uic-SquaredTabs-count_hidden")}>0</h6>
          <div>
            <span
            className={clsx(
              isSelected ?
              "Uic-SquaredTabs-label_sel" :
              "Uic-SquaredTabs-label",
              picture || count === "" ? "Uic-SquaredTabs-item_text" : {}
            )}>

              {label}
            </span>
          </div>
        </>
      }
      <p className={clsx("Uic-SquaredTabs-label", "Uic-SquaredTabs-text_soon")}>
        {!status && disabled ?
        <FormattedMessage id="UIC.SQUARED_TABS.COMING_SOON" /> :

        ""
        }
      </p>
    </Button>);

}

SquaredTab.propTypes = propTypes;


export default SquaredTab;
